// extracted by mini-css-extract-plugin
export default {"root":"RTYJw","isBadgeShown":"uh6e3","showHoverAnimation":"XnO6X","mostPopular":"G2yN3","currentPlan":"wVDmM","box":"Sy5mh","isMostPopular":"bLDC3","name":"BMWvn","slogan":"lxdMm"};